import { gql } from '@apollo/client';

export const FETCH_DELEGANTI = gql`
  query fetchDeleganti($where: FamigliariWhereInput) {
    famigliaris(where: $where) {
      edges {
        node {
          id
          objectId
          defunto_pointer {
            objectId
          }
          org_pointer {
            objectId
          }
          nome
          cognome
          codice_fiscale
          rilasciato
          data_rilascio
          data_nascita
          luogo_nascita
          provincia_luogo_nascita
          grado_parentela
          documento_numero
          documento_riconoscimento
          indirizzo
          rilasciato
          cap
          stato
          telefono
          cellulare
          codice_fiscale
          citta
          email
          sesso
        }
      }
    }
  }
`;

export const FETCH_DELEGANTI_BY_DEFUNTO_JOIN = gql`
  query fetchDelegantiByDefuntoJoin($where: Join_famigliari_defuntoWhereInput) {
    join_famigliari_defuntos(
      where: $where
      first: 100
      order: [createdAt_ASC]
    ) {
      edges {
        node {
          objectId
          grado_parentela
          principale
          stato
          famigliari_pointer {
            id
            objectId
            org_pointer {
              objectId
            }
            nome
            cognome
            codice_fiscale
            rilasciato
            data_rilascio
            data_nascita
            luogo_nascita
            provincia_luogo_nascita
            documento_numero
            documento_riconoscimento
            indirizzo
            cap
            telefono
            cellulare
            citta
            email
            sesso
          }
        }
      }
    }
  }
`;

export const FETCH_CLIENTI_BY_DEFUNTO_JOIN = gql`
  query fetchClientiByDefuntoJoin($where: Join_clienti_defuntoWhereInput) {
    join_clienti_defuntos(where: $where, first: 100, order: [createdAt_ASC]) {
      edges {
        node {
          objectId
          cliente_pointer {
            objectId
            nome
            cognome
            email
            cellulare
            telefono
          }
        }
      }
    }
  }
`;
